import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=274f3f16&scoped=true"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"
import style0 from "./Module.vue?vue&type=style&index=0&id=274f3f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f3f16",
  null
  
)

export default component.exports